// The mvnpm/npm package resolves to htmx's ESM build under the bundler, which
// keeps htmx module-local: it still boots itself and binds hx- attributes, but
// nothing is published on window. Inline scripts and other bundles call the
// global (htmx.process, htmx.ajax, htmx.trigger), so publish it here.
import htmx from 'htmx.org';

window.htmx = htmx;
